<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-10 09:44:48
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-20 15:23:42
 * @FilePath: \hzs-nutra-wecom-shop\src\views\BuyerProxyPayment\createCustomer.vue
 * @Description: 代客下单 - 创建客户
-->
<template>
  <div class="page-container">
    <div class="mainContent">
      <van-form ref="formRef" @submit="onSubmit">
        <!-- 姓名 -->
        <van-field
          v-model="formData.name"
          name="name"
          placeholder="请输入"
          input-align="right"
          :rules="[{ required: true, message: '请填写姓名' }]"
        >
          <template #label> <span class="required-mark">*</span>姓名 </template>
        </van-field>

        <!-- 手机号码 -->
        <van-field
          v-model="formData.phone"
          name="phone"
          type="tel"
          placeholder="请输入11位手机号"
          maxlength="11"
          input-align="right"
          :rules="[
            { required: true, message: '请填写手机号' },
            { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确' },
          ]"
        >
          <template #label>
            <span class="required-mark">*</span>手机号码
          </template>
        </van-field>

        <!-- 生日 (点击弹出选择器) -->
        <van-field
          v-model="formData.birthday"
          is-link
          readonly
          name="birthday"
          placeholder="请选择生日"
          input-align="right"
          :rules="[{ required: true, message: '请选择日期' }]"
          @click="showBirthdayPicker = true"
        >
          <template #label> <span class="required-mark">*</span>生日 </template>
        </van-field>

        <!-- 性别 -->
        <van-field
          name="sex"
          input-align="right"
          :rules="[{ required: true, message: '请选择性别' }]"
        >
          <template #label> <span class="required-mark">*</span>性别 </template>
          <template #input>
            <van-radio-group v-model="formData.sex" direction="horizontal">
              <van-radio :name="1" checked-color="#d4b488">男</van-radio>
              <van-radio :name="2" checked-color="#d4b488">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <!-- 所在区域 (点击弹出省市区) -->
        <van-field
          v-model="formData.areaText"
          is-link
          readonly
          name="area"
          placeholder="请选择省市区"
          input-align="right"
          :rules="[{ required: true, message: '请选择省市区' }]"
          @click="showAreaPicker = true"
        >
          <template #label>
            <span class="required-mark">*</span>所在区域
          </template>
        </van-field>

        <!-- 详细地址 -->
        <van-field
          v-model="formData.address"
          rows="3"
          autosize
          type="textarea"
          input-align="right"
          :rules="[
            { required: true, message: '请输入详细信息（街道、楼牌号）' },
          ]"
          placeholder="请输入详细信息（街道、楼牌号）"
        >
          <template #label>
            <span class="required-mark">*</span>详细地址
          </template>
        </van-field>
      </van-form>

      <!-- 底部提示文字 -->
      <div class="tips-container">
        请提醒客户：<br />
        订单信息以及赠送积分将绑定当前手机号，请确保手机号真实有效
      </div>
    </div>

    <!-- 底部保存按钮 -->
    <div class="bottom_button_box">
      <van-button
        round
        block
        type="primary"
        color="#DCBB89"
        class="save-btn"
        @click="onSubmit"
      >
        保 存
      </van-button>
    </div>

    <!-- 生日选择器弹窗 -->
    <van-popup v-model:show="showBirthdayPicker" position="bottom">
      <van-date-picker
        v-model="currentDate"
        title="选择生日"
        @confirm="onBirthdayConfirm"
        @cancel="showBirthdayPicker = false"
        :min-date="new Date(1900, 0, 1)"
        :max-date="new Date()"
      />
    </van-popup>

    <!-- 省市区选择器弹窗 -->
    <van-popup v-model:show="showAreaPicker" position="bottom">
      <van-cascader
        v-model="currentArea"
        title="选择地区"
        :options="areaList_"
        :field-names="fieldNames"
        @close="showAreaPicker = false"
        @finish="onAreaConfirm"
      />
    </van-popup>
  </div>
</template>

<script lang="ts" setup>
import dayjs from "dayjs";
// import { areaList } from "@vant/area-data";
import CustomerApi from "@/utils/api/customer";
import OtherApi from "@/utils/api/other";
import { showSuccessToast, showFailToast } from "vant";

// --------------------------------------- 变量
const router = useRouter();
const route = useRoute();
const { user_uuid, returnBack, returnBackQuery } = route.query;

const formRef = ref();
// 表单数据
const formData = ref({
  name: undefined,
  phone: undefined,
  birthday: undefined,
  sex: undefined, // 默认男
  areaText: undefined,
  address: undefined,
  province_id: undefined,
  city_id: undefined,
  area_id: undefined,
});
let isSubmit = false;
const areaList_ = ref([]);
const fieldNames = {
  text: "ext_name",
  value: "id",
  children: "children",
};

// 弹窗控制
const showBirthdayPicker = ref(false);
const showAreaPicker = ref(false);

// 日期选择器初始值 (今天)
const currentDate = ref(new Date().toISOString().split("T")[0].split("-"));

// 区域选择器初始值 (空)
const currentArea = ref([]);

// 确认生日
const onBirthdayConfirm = ({ selectedValues }) => {
  formData.value.birthday = selectedValues.join("-");
  showBirthdayPicker.value = false;
};

// 确认区域
const onAreaConfirm = ({ selectedOptions }) => {
  formData.value.areaText = selectedOptions
    .map((option) => option.ext_name)
    .join(" ");

  formData.value.province_id = selectedOptions[0].id;
  formData.value.city_id = selectedOptions[1].id;
  formData.value.area_id = selectedOptions[2].id;

  showAreaPicker.value = false;
};

// 提交表单
const onSubmit = async () => {
  if (isSubmit) return;
  isSubmit = true;

  let valid = await formRef.value.validate();
  if (valid) return;

  let res = null;
  let resWord = "";
  if (formData.value.user_uuid) {
    resWord = "编辑客户";
    res = await CustomerApi._customerEdit(formData.value);
  } else {
    resWord = "创建客户";
    res = await CustomerApi._customerAdd(formData.value);
  }

  isSubmit = false;
  if (res?.code === 200) {
    showSuccessToast(`${resWord}成功！`);
    router.push({
      path: "/createCustomerSuc",
      query: {
        user_uuid: res?.data?.user_uuid || formData.value.user_uuid,
        returnBack,
        returnBackQuery,
      },
    });
  } else {
    showFailToast(`${resWord}失败！${res?.msg || ""}`);
  }
};
// --------------------------------------- 方法、事件
onMounted(async () => {
  await getArea();

  if (user_uuid) {
    getDetail();
  }
});
// --------------------------------------- 请求
async function getDetail() {
  let res = await CustomerApi._customerInfo({ user_uuid }).catch((err) => {});
  formData.value = {
    ...(res?.data?.user_base_info || {}),
    birthday: res?.data?.user_base_info?.birthday
      ? dayjs(res?.data?.user_base_info?.birthday).format("YYYY-MM-DD")
      : undefined,
  };

  await nextTick();
  let areas = [];
  areaList_.value?.forEach((v1) => {
    if (v1.id == formData.value.province_id) {
      areas.push(v1.ext_name);
      if (v1.children) {
        v1.children.forEach((v2) => {
          if (v2.id == formData.value.city_id) {
            areas.push(v2.ext_name);
            if (v2.children) {
              v2.children.forEach((v3) => {
                if (v3.id == formData.value.area_id) {
                  areas.push(v3.ext_name);
                }
              });
            }
          }
        });
      }
    }
  });

  formData.value.areaText = areas.join(" ");
}
async function getArea() {
  let res = await OtherApi._areaMap().catch(() => {});
  areaList_.value = res?.data || [];
}
</script>

<style lang="scss" scoped>
/* @use 'xxx.scss' as *; */
/*
    .page-container
        ---- 主体内容
        .mainContent

        ---- 底部操作栏
        .bottom_button_box
    @supports

    **** 在 @/scss/common.scss ****
*/

.page-container {
  .mainContent {
    /* 表单容器 */
    .form-card {
      background: #fff;
      margin-top: 16px;
      padding: 0 16px;

      background: #ffffff;
      border-radius: 8px;
    }

    /* 必填星号样式 */
    .required-mark {
      color: #ee0a24;
      margin-right: 4px;
    }

    /* 标签字体颜色 */
    .van-cell__title {
      color: #323233;
      font-size: 15px;
    }

    /* 输入框占位符颜色 */
    .van-field__placeholder {
      color: #c8c9cc;
    }

    /* 性别选择器特殊调整 */
    .gender-group {
      display: flex;
      justify-content: flex-end; /* 靠右对齐，模仿截图 */
      align-items: center;
      padding: 12px 0;
    }

    .van-radio {
      margin-left: 20px;
    }

    .van-radio__icon--checked .van-icon {
      background-color: #d48e58; /* 选中态金色 */
      border-color: #d48e58;
    }

    input,
    :deep(input) {
      &:-internal-autofill-selected {
        background-color: transparent !important;
      }
    }
  }

  /* 底部提示文字区域 */
  .tips-container {
    margin: 20px 0;
    font-size: 13px;
    line-height: 1.6;
    color: #ee0a24; /* 红色提示 */
  }

  /* 隐藏原生滚动条但保留功能 */
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
    background: transparent;
  }
}
</style>
